import React from "react";
import { Box, Typography, Button, Paper, Container } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Home as HomeIcon } from "@mui/icons-material";
import { LogoImage } from "../components/layout/Logo";

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Paper
          elevation={3}
          sx={{
            p: 6,
            width: "100%",
            textAlign: "center",
            background: "linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%)",
          }}
        >
          <LogoImage height={80} />

          <Typography
            variant="h1"
            sx={{
              fontSize: "6rem",
              fontWeight: "bold",
              color: "#174B67",
              mb: 2,
              textShadow: "0 2px 4px rgba(0,0,0,0.1)",
            }}
          >
            404
          </Typography>

          <Typography
            variant="h4"
            gutterBottom
            sx={{
              color: "#174B67",
              fontWeight: 500,
              mb: 2,
            }}
          >
            Page Not Found
          </Typography>

          <Typography
            variant="body1"
            color="text.secondary"
            sx={{
              mb: 4,
              fontSize: "1.1rem",
              lineHeight: 1.6,
            }}
          >
            Oops! The page you're looking for doesn't exist or has been moved.
            Let's get you back to your family activities.
          </Typography>

          <Box
            sx={{
              display: "flex",
              gap: 2,
              justifyContent: "center",
              flexWrap: "wrap",
            }}
          >
            <Button
              variant="contained"
              size="large"
              startIcon={<HomeIcon />}
              onClick={() => navigate("/dashboard")}
              sx={{
                backgroundColor: "#174B67",
                "&:hover": {
                  backgroundColor: "#2BB3A3",
                },
                borderRadius: 2,
                px: 3,
                py: 1.5,
              }}
            >
              Go to Dashboard
            </Button>

            <Button
              variant="outlined"
              size="large"
              onClick={() => navigate("/activities")}
              sx={{
                borderColor: "#2BB3A3",
                color: "#2BB3A3",
                "&:hover": {
                  borderColor: "#174B67",
                  color: "#174B67",
                  backgroundColor: "transparent",
                },
                borderRadius: 2,
                px: 3,
                py: 1.5,
              }}
            >
              View Activities
            </Button>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
};

export default NotFound;
